import type { Clerk } from "@clerk/clerk-js";
import {
  createContextId,
  useContext,
  type NoSerialize,
  type Signal,
} from "@builder.io/qwik";
import { useContextProvider } from "@builder.io/qwik";

type ClerkContextPayload = Signal<NoSerialize<Clerk>>;

export const ClerkContext =
  createContextId<ClerkContextPayload>("ClerkContext");

export const useProvideClerk = (clerk: Signal<NoSerialize<Clerk>>) => {
  useContextProvider(ClerkContext, clerk);
};

export const useClerk = (): ClerkContextPayload => {
  return useContext(ClerkContext);
};
